import { Button, Alert } from '@dreamtree-org/twreact-ui';
import { useAppApi } from '@/lib/api';
import { StatusBadge } from '@/components';
import { useVendorSession } from '../VendorApp';
import { VendorAuthFrame } from './SignIn';

const COPY = {
  pending: { variant: 'info', title: 'Your request is being reviewed', body: 'The store will approve your account soon. Sign in again later to start listing products.' },
  rejected: { variant: 'error', title: 'Your request was not approved', body: 'Contact the store if you think this is a mistake.' },
  suspended: { variant: 'warning', title: 'Your account is suspended', body: 'Your products are off the storefront. Contact the store to be reinstated.' },
};

/** What a signed-in vendor that is not (yet) approved sees. */
export default function Status({ store }) {
  const { vendor, reload } = useVendorSession();
  const { fetchApi } = useAppApi();
  const c = COPY[vendor.status] || COPY.pending;
  const signOut = async () => {
    try { await fetchApi('vendorSignOut'); } catch { /* already gone */ }
    reload();
  };
  return (
    <VendorAuthFrame store={store} title={vendor.business_name} subtitle={vendor.email}>
      <div className="flex justify-center"><StatusBadge status={vendor.status} /></div>
      <Alert variant={c.variant} title={c.title}>{c.body}{vendor.review_note ? ` Reason: ${vendor.review_note}` : ''}</Alert>
      <div className="flex gap-2">
        <Button variant="outline" className="flex-1" onClick={reload}>Check again</Button>
        <Button variant="ghost" className="flex-1" onClick={signOut}>Sign out</Button>
      </div>
    </VendorAuthFrame>
  );
}
